import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const routingSlice = createSlice({
  name: 'routing',
  initialState: {
    routing: [],
  },
  reducers: {
    setRouting: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        routing: payload,
      };
    },
  },
});

export const { setRouting } = routingSlice.actions;

export default routingSlice.reducer;
